export const VirtualRaceTypeValues = [
    'None',
    'Section',
    'CupIndividualProlog',
    'CupSameLevel',
    'CupUci',
    'CupFis',
    'BestLap',
    'ShowUrl',
    'ShowTriggerControl',
    'CUPNSFUPDOWN',
] as const;
export type VirtualRaceType = (typeof VirtualRaceTypeValues)[number];
